import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationInstructions = () => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Icon name="Info" className="w-5 h-5 mr-2 text-blue-600" />
        What to do next:
      </h2>
      
      <ol className="space-y-3 text-gray-700">
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-semibold mr-3 mt-0.5">
            1
          </span>
          <span>
            <strong>Check your inbox first</strong> - The verification email may take 1-2 minutes to arrive. Please wait before requesting a new one.
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-semibold mr-3 mt-0.5">
            2
          </span>
          <span>
            <strong>Click the verification link</strong> in the email to activate your account. The link is valid for 24 hours.
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-semibold mr-3 mt-0.5">
            3
          </span>
          <span>
            <strong>Return to sign in</strong> once your email is verified to access your account.
          </span>
        </li>
      </ol>

      <div className="mt-6 pt-4 border-t border-blue-200">
        <p className="text-sm text-gray-600 flex items-start mb-3">
          <Icon name="AlertCircle" className="w-4 h-4 mr-2 text-amber-600 flex-shrink-0 mt-0.5" />
          <span>
            <strong>Can't find the email?</strong> Check your spam or junk folder. Add{' '}
            <span className="font-semibold text-blue-600">support@mybodytoday1.com</span> to your contacts to ensure you receive our emails.
          </span>
        </p>
        
        <div className="bg-white border border-blue-200 rounded-lg p-4">
          <p className="text-sm font-semibold text-gray-900 mb-2 flex items-center">
            <Icon name="HelpCircle" className="w-4 h-4 mr-2 text-blue-600" />
            If you didn't receive the verification link:
          </p>
          <ul className="text-sm text-gray-700 space-y-1 ml-6 list-disc">
            <li><strong>Wait 5 minutes</strong> - Email delivery can be delayed</li>
            <li><strong>Use the same email address</strong> - Click "Resend Verification Email" below (60-second cooldown between resends)</li>
            <li><strong>Do NOT create a new account</strong> - This will cause duplicate account issues</li>
            <li><strong>Check all folders</strong> - Including Promotions, Updates, and Social tabs in Gmail</li>
          </ul>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-sm text-gray-600 flex items-start">
          <Icon name="Clock" className="w-4 h-4 mr-2 text-gray-500 flex-shrink-0 mt-0.5" />
          <span>
            The verification link will expire in <strong>24 hours</strong>. If it expires, you can request a new one using the button below.
          </span>
        </p>
      </div>
    </div>
  );
};

export default VerificationInstructions;